import config from './config'
import { profile } from '../stores/storages/ProfileStorage'
import api from './api'
import formatter from './formatter'
import axios from 'axios'
import { NODE_TYPE_MESSAGE, GROUP_ROLE, RESTORE_SUBTYPE_MESSAGE, NODE_SUBTYPE_MESSAGE } from '../tinode/constants'
import * as Const from '../tinode/config'
import * as MC_CONST from '../tinode/constants'
import { MAX_IMAGE_DIM, QUOTED_REPLY_LENGTH } from '../config'
import MessagesUtil from "../tinode/messagesUtils";
import Drafty from '../tinode/drafty'
import Helpers from '../lib/helpers'
import AccessMode from '../tinode/access-mode'
import { Topic } from '../tinode/topic'

const JSZip = require("jszip");

const crypto = require("crypto");

const MAX_RETRY_TIME = 5

const RESTORE_STATUS = {
  PROCESSING: 'processing',
  DONE: 'done',
  NEED_RETRY: 'need_retry',
  FAIL: 'fail',
  DO_NOT_RESTORE: 'do_not_restore',
}

class RestoreServices {
  retries = 1;
  success = false;
  backupInfo = null;

  tinode = null

  constructor(tinode) {
    this.setTinode(tinode)
  }

  start

  setTinode(tinode) {
    this.tinode = tinode
  }

  restoreBackupMessages = (tinode, retries) => {
    if (typeof profile.restoreStatus === 'undefined') {
      if (retries > MAX_RETRY_TIME) {
        this.tinode.showBackupLoading(false)
        profile.restoreStatus = RESTORE_STATUS.FAIL
        return
      }

      profile.restoreStatus = RESTORE_STATUS.PROCESSING

      this.setTinode(tinode)
      if (retries) this.retries = retries;
      this.success = false;
      if (this.retries > 0) {
        this.tinode.disconnect()
        this.start = new Date().getTime()
        this.tinode.showBackupLoading(true)
        this.getBackUpInfo().then(this.downloadBackupFile);
      }
    } else {
      if (this.tinode) {
        this.tinode.showBackupLoading(false)
      }
      tinode.logger('================do not process', profile.restoreStatus)
    }

  };

  getBackUpInfo = async () => {
    const { username: msisdn, token } = profile.authAPI;
    const timestamp = new Date().getTime();
    const security = formatter.encrypt(`${msisdn}${token}${timestamp}`);
    const data = {
      params: {
        msisdn,
        timestamp,
        security,
      },
    };
    const options = null;
    const res = await api.request({
      //api.request
      method: config.endpoints.restore.restoreBackupMsg.method,
      path: config.endpoints.restore.restoreBackupMsg.path,
      host: config.host,
      data,
      options,
    });
    if (res) {
      return res;
    }
    return null;
  };

  downloadBackupFile = (backupInfo) => {
    try {
      const lstFile = backupInfo?.lstFile;
      if (lstFile !== undefined && lstFile.length > 0) {
        const fileUrl = `${config.host}/${lstFile[0].path}`;
        window.logger("RestoreServices|downloadBackupFile|backupFilePath=", fileUrl);
        try {
          axios
            .request({
              url: fileUrl,
              method: "GET",
              responseType: "arraybuffer",
            })
            .then((data) => {
              if (data.status === 200) {
                this.decryptBackupWithBuffer(data.data);
              } else {
                window.logger("RestoreServices|downloadBackupFile|fileDownloader error|data.status=", data.status);
                this.retryRestoreBackup(tinode)
              }
            });
        } catch (err) {
          window.logger("RestoreServices|downloadBackupFile|fileDownloader error|", err.stack);
          this.retryRestoreBackup(tinode)
        }
      } else {
        window.logger("RestoreServices|downloadBackupFile|showPopup Notification Restore Fail");
        this.showRestoreFail()
      }
    } catch (e) {
      //retry backup
      window.logger("RestoreServices|downloadBackupFile error|", e.stack);
      this.retryRestoreBackup(tinode)
    }
  };

  decryptBackupWithBuffer = (buffer) => {
    const encryptedText = Buffer.from(buffer, "base64");
    const keyBuf = Buffer.from("bW9jaGFfYmFja3VwX21lc3NhZ2VfYWVzcGFzc3dvcmQ=", "base64");
    const iv = new Uint8Array(16);
    const decipher = crypto.createDecipheriv("aes-256-cbc", keyBuf, iv);
    let decrypted = decipher.update(encryptedText);
    decrypted = Buffer.concat([decrypted, decipher.final()]);
    window.logger("decryptBackupWithBuffer|buffer=", buffer, "|decrypted|", decrypted);
    // Create a new instance of JSZip
    const zip = new JSZip();
    // Load the ZIP file
    zip.loadAsync(decrypted).then((zip) => {
      // Specify the file you want to extract
      const targetFileName = "backup_message.txt";
      // Check if the file exists in the ZIP archive
      if (zip.files[targetFileName]) {
        // Extract the content of the file
        return zip.files[targetFileName].async("string");
      } else {
        throw new Error(`File not found: ${targetFileName}`);
      }
    })
      .then((fileContent) => {
        // Handle the extracted content
        this.backupMessage(fileContent)
      })
      .catch((err) => {
        console.error("Error extracting the file:", err);
      });
  };

  async backupMessage(data) {
    const dataArr = (data.substring(1)).split('\n1')
    const promCreateThread = []
    dataArr.forEach((threadData) => {
      const threadLines = threadData.split('\n')
      const tJson = threadLines.shift()
      const threadInfo = JSON.parse(tJson)

      const listMsg = threadLines.filter(m => m !== '').map((mJson) => {
        const msg = JSON.parse(mJson)
        return msg
      })

      const thread = new ThreadBackup(this.tinode, threadInfo, listMsg)
      promCreateThread.push(thread.saveThread())
    })

    Promise.all(promCreateThread).then((res) => {
      profile.restoreStatus = RESTORE_STATUS.DONE
      // Cập nhật giao diện chat list
      setTimeout(() => {
        this.tinode.showBackupSuccess()
        // alert(`Execute time = ${new Date().getTime() - this.start}`)

        setTimeout(() => {
          this.tinode.showBackupLoading(false)
          window.location.reload()
        }, 2000)
      })
    })
  };

  retryRestoreBackup = (tinode) => {
    if (typeof profile.restoreStatus === 'undefined') {
      this.restoreBackupMessages(tinode, 1)
    } else if (profile.restoreStatus === RESTORE_STATUS.NEED_RETRY) {
      this.restoreBackupMessages(tinode, this.retries + 1)
    }
  }

  showRestoreFail = () => {
    window.logger('restore backup failed')
    this.tinode.showBackupLoading(false)
  }
}

class ThreadBackup {
  tinode
  type
  numbers
  name
  state
  threadId
  unread
  draft
  tDraft
  avt
  admins
  pin
  tChange
  class
  isStranger
  listMessage

  constructor(tinode, threadInfo, listMessage) {
    this.numbers = []
    this.admins = []

    this.setThread(tinode, threadInfo)
    this.setListMessage(listMessage)
  }

  setThread = (tinode, threadInfo) => {
    this.tinode = tinode
    this.type = this.setType(threadInfo.type)
    this.numbers = this.setNumbers(threadInfo.numbers)
    this.name = threadInfo.name
    this.state = threadInfo.state
    this.threadId = threadInfo.svId
    this.unread = threadInfo.unread
    this.draft = threadInfo.draft
    this.tDraft = threadInfo.tDraft
    this.avt = threadInfo.avt
    this.admins = this.setAdmins(threadInfo.admins)
    this.pin = this.setPin(threadInfo.pin)
    this.tChange = threadInfo.tChange
    this.class = threadInfo.class
    this.isStranger = threadInfo.isStranger
  }

  setType = (type) => {
    switch (type) {
      case 100:
        return NODE_TYPE_MESSAGE.CHAT
      case 101:
        return NODE_TYPE_MESSAGE.GROUPCHAT
      default:
        return ''
    }
  }

  setNumbers = (numbers) => {
    if (typeof numbers === 'undefined') {
      return []
    }
    const listNumber = []
    const lNumber = numbers.split(',')
    lNumber.forEach((e) => {
      if (e !== '') {
        const member = {
          jid: e,
          name: e,
          role: GROUP_ROLE.MEMBER,
        }
        listNumber.push(member)
      }
    })
    return listNumber
  }

  setAdmins = (admins) => {
    if (typeof admins === 'undefined') {
      return []
    }
    const listAdmin = []
    const lAdmin = admins.split(',')
    lAdmin.forEach((e) => {
      if (e !== '') {
        const admin = {
          jid: e,
          name: e,
          role: GROUP_ROLE.ADMIN,
        }
        listAdmin.push(admin)
      }
    })
    return listAdmin
  }

  setPin = (pin) => {
    if (typeof pin !== 'undefined' && pin !== '') {
      return JSON.parse(pin)
    }
    return pin
  }

  setListMessage = (listMessage) => {
    this.listMessage = []
    listMessage.forEach((mInfo) => {
      const msg = new MessageBackup(this, this.type, this.threadId, mInfo)
      if (msg.isValid()) {
        this.listMessage.push(msg)
      }
    })
  }

  getMessageById = (id) => {
    const listMsg = this.listMessage.filter(msg => msg.id === id)
    if (listMsg.length > 0) {
      return listMsg[0]
    }
    return null
  }

  saveThread() {
    return new Promise((resolve, reject) => {
      try {
        const promCreateMessage = []

        const topicName = MessagesUtil.getTopicId(this.type, this.threadId)

        const topic = this.tinode.getTopic(topicName)
        topic.acs = new AccessMode({
          given: "JRWPASDO",
          want: "JRWPASDO",
          mode: "JRWPASDO",
        })

        if (this.type === NODE_TYPE_MESSAGE.GROUPCHAT) {
          const groupName = this.name
          const members = this.admins.concat(this.numbers).map((m) => {
            return m;
          })
          topic.public = {
            fn: groupName,
            note: "",
          }
          topic.sub = members.map((mem) => {
            const jid = mem.jid;
            const role = mem.role
            return this.tinode.makeGroupMember(jid, role, mem)
          })
        } else {
          if (!!!topic.public) {
            topic.public = {
              fn: this.threadId,
            }
          }
        }

        topic.name = topicName
        topic.topic = topicName

        topic.seq = Array.isArray(this.listMessage) ? this.listMessage.length : 0
        topic.read = topic.seq - this.unread
        topic.recv = topic.seq

        if (this.listMessage.length > 0) {
          topic.touched = new Date(Number(this.listMessage[this.listMessage.length - 1].timeReceive))
        }

        this.tinode._db.updTopic(topic).then(async () => {
          window.logger('insert topic success', topic.name, topic)
          const listMessage = this.listMessage.map((msg, index) => msg.formatMessage(topic, index + 1))
          this.tinode.saveMultiMessage(topic, listMessage)
           window.logger("topic then format message =",topic)
          if ((Array.isArray(topic.shareImage) && topic.shareImage.length > 0) || (Array.isArray(topic.shareFile) && topic.shareFile.length > 0)) {
            // this.tinode._db.updTopic(topic)
            //update database
            //  topic.udpTopicInfo(topic);
            window.logger("topic then update database|RUN|UD|topic=", topic)
            await this.tinode._db.updTopic(topic).then(res => {
              window.logger("topic then update database|then=",res)
            }).catch(error =>{
              window.logger("topic then update database|ERROR=",error)
            });
          }
          resolve(topic)
        }).catch(e => {
          console.error(e)
          resolve(null)
        })
      } catch (e) {
        resolve(null)
      }
    })
  }

}

class MessageBackup {
  tinode
  id
  from
  to
  threadId
  cMode
  body
  reply
  sAvatar
  timeReceive
  tag
  status
  directLinkMedia
  duration
  fileName
  filePath
  fileSize
  imageUrl
  ratio

  type
  subtype
  readState

  constructor(thread, type, threadId, messageInfo) {
    this.thread = thread
    this.tag = []
    this.threadId = threadId

    this.setMessageInfo(type, messageInfo)
  }

  isValid = () => {
    switch (this.subtype) {
      case NODE_SUBTYPE_MESSAGE.IMAGE:
      case NODE_SUBTYPE_MESSAGE.FILE:
      case NODE_SUBTYPE_MESSAGE.VIDEO:
      case NODE_SUBTYPE_MESSAGE.AUDIO:
        return !!this.directLinkMedia
      default:
        return true
    }
  }

  // {
  //    "body": "1111",
  //    "cMode": 0,
  //    "duration": "0",
  //    "fileSize": "0",
  //    "from": "0397585436",
  //    "stp": "text",
  //    "pId": "0502000_XSYMVQJ1SQIXOMVNZC2XPNFDI59HMEAK",
  //    "readState": 0,
  //    "status": 4,
  //    "svId": "0397585436_1701741729695",
  //    "t": 1701741732258,
  //    "to": "0396783058"
  //}
  setMessageInfo = (type, messageInfo) => {
    if (messageInfo) {
      this.type = type
      this.id = messageInfo.pId
      this.from = messageInfo.from
      this.to = messageInfo.to
      this.cMode = messageInfo.cMode
      this.body = messageInfo.body
      this.reply = this.setReply(messageInfo.reply)
      this.sAvatar = messageInfo.sAvatar
      this.timeReceive = messageInfo.t
      this.subtype = this.setSubtype(messageInfo.stp)
      this.tags = this.setTag(messageInfo.tag)
      this.status = messageInfo.status
      this.readState = messageInfo.readState
      this.directLinkMedia = messageInfo.directLinkMedia
      this.duration = messageInfo.duration
      this.fileName = messageInfo.fileName
      this.filePath = messageInfo.filePath
      this.fileSize = messageInfo.fileSize
      this.imageUrl = messageInfo.imageUrl
      this.ratio = Number(messageInfo.ratio)
    }
  }

  setSubtype = (stp) => {
    switch (stp) {
      case RESTORE_SUBTYPE_MESSAGE.TEXT:
        return NODE_SUBTYPE_MESSAGE.TEXT
      case RESTORE_SUBTYPE_MESSAGE.IMAGE:
        return NODE_SUBTYPE_MESSAGE.IMAGE
      case RESTORE_SUBTYPE_MESSAGE.FILE:
        return NODE_SUBTYPE_MESSAGE.FILE
      case RESTORE_SUBTYPE_MESSAGE.VIDEO:
        return NODE_SUBTYPE_MESSAGE.VIDEO
      case RESTORE_SUBTYPE_MESSAGE.AUDIO:
        return NODE_SUBTYPE_MESSAGE.AUDIO
      default:
        return NODE_SUBTYPE_MESSAGE.TEXT
    }
  }

  setReply = (reply) => {
    if (typeof reply === 'undefined') {
      return reply
    }
    const rJson = '['.concat(reply, ']')
    const replyJson = JSON.parse(rJson)
    if (replyJson.length > 0) {
      const result = replyJson[0]
      if (replyJson.link) result.media_link = result.link
      const replyResult = {
        ...result,
        media_link: result.link,
      }
      return replyResult
    }
    return null
  }

  setTag = (tag) => {
    try {
      if (typeof tag === 'undefined' || tag === '') {
        return tag
      }
      const tagJSON = JSON.parse(tag)
      const listTag = []
      tagJSON.forEach((t) => {
        listTag.push(t)
      })
      return listTag
    } catch (e) {
      return []
    }

  }

  getState = (state) => {
    switch (state) {
      case 6:
        return Const.MESSAGE_STATUS_SENDING
      case 1:
        return Const.MESSAGE_STATUS_SENT
      case 3:
        return Const.MESSAGE_STATUS_RECEIVED
      case 8:
        return Const.MESSAGE_STATUS_READ
      case 2:
        return Const.MESSAGE_STATUS_FAILED
      default:
        return Const.MESSAGE_STATUS_TO_ME
    }
  }

  getDelivered = (status) => {
    switch (status) {
      case Const.MESSAGE_STATUS_SENT:
        return MC_CONST.MESSAGE_DELIVERED.SENT;
      case Const.MESSAGE_STATUS_RECEIVED:
        return MC_CONST.MESSAGE_DELIVERED.RECEIVED;
      case Const.MESSAGE_STATUS_READ:
        return MC_CONST.MESSAGE_DELIVERED.SEEN_MULTI_MESSAGES;
      case Const.MESSAGE_STATUS_FAILED:
        return MC_CONST.MESSAGE_DELIVERED.FAILED;
    }
    return null
  }

  formatMessage = (topic, seq, isUpdate = true) => {
    const _status = this.getState(this.status)
    const msgData = {
      threadId: this.threadId,
      content: this.body,
      id: this.id,
      from: `usr${this.from}`,
      topic: topic.name,
      ts: new Date(Number(this.timeReceive)),
      _status: _status,
      _sending: false,
      seq,
      type: this.type,
      subtype: this.subtype,
    }
    const delivered = this.getDelivered(_status)
    if (delivered !== null) {
      msgData.delivered = delivered
    }

    if (this.tags) {
      msgData.tags = this.tags
    }

    if (isUpdate) {
      this.updateMsgData(topic, this.subtype, msgData)
    }


    return msgData
  }

  updateMsgData(topic, subtype, msgData) {
    switch (subtype) {
      case NODE_SUBTYPE_MESSAGE.TEXT: {
        if (this.reply) {
          const { msgId, subtype } = this.reply;
          let replyMsg = this.thread.getMessageById(msgId)
          let index = 1
          if (replyMsg) {
            replyMsg = replyMsg.formatMessage(topic, index, subtype !== NODE_SUBTYPE_MESSAGE.TEXT);

            if (replyMsg) {
              const senderId = replyMsg.from;

              let senderName = Topic.getThreadId(replyMsg.from);
              const topicSender = this.thread.tinode.getTopicByName(senderId)
              if (topicSender) {
                senderName = Topic.getTopicName(topicSender)
              }
              const content = Drafty.replyContent(replyMsg.content, QUOTED_REPLY_LENGTH);
              const replyContent = {
                content: Drafty.quote(senderName, senderId, content),
                seq: replyMsg.seq,
              };
              replyContent.content.txt = replyContent.content.txt + msgData.content;
              replyContent.content.replyBody = msgData.content
              replyContent.content.replyMsg = replyMsg
              msgData.content = replyContent.content;
              msgData.head = {
                mime: Drafty.getContentType(),
                reply: "" + replyContent.seq,
              };
            }
          }
        }
        break
      }
      /**
        {
            "body": "",
            "cMode": 0,
            "directLinkMedia": "/hlmocha223/media1/file/2023/11/24/0396/7830/58/aad7b4441b49c65376da27160b6a4c05.jpg",
            "duration": "0",
            "fileName": "ab3ad4442290390fc75b3292a3b32fce_1700795514665.jpg",
            "filePath": "/storage/emulated/0/Android/data/com.viettel.mocha.app.mochatest/files/Mocha Images/0502000_VQJCSFVBQTUZ7Z1676T201EI3IKW2COL.jpg",
            "fileSize": "0",
            "from": "0396783058",
            "stp": "image",
            "pId": "0502000_VQJCSFVBQTUZ7Z1676T201EI3IKW2COL",
            "ratio": "1.501466275659824",
            "readState": 1,
            "status": 8,
            "svId": "0396783058_1700789931004",
            "t": 1700795514129,
            "to": "0396783058"
        }
      */
      case NODE_SUBTYPE_MESSAGE.IMAGE: {
        const height = this.ratio < 1 ? MAX_IMAGE_DIM : (MAX_IMAGE_DIM / this.ratio)
        const width = this.ratio < 1 ? (MAX_IMAGE_DIM * this.ratio) : MAX_IMAGE_DIM
        const imageMsg = Drafty.insertImage(null, 0, {
          mime: Helpers.getMimeType(this.fileName),
          width: width,
          height: height,
          filename: this.fileName,
          size: this.fileSize,
          refurl: this.directLinkMedia,
        });
        msgData.content = imageMsg;
        msgData.head = { mime: Drafty.getContentType() };
        window.logger("addTopicSharedImage|topic=",topic.name,"|id=",this.id,"|url=",this.directLinkMedia)

        this.addTopicSharedImage(topic, this.id, this.directLinkMedia);
        break
      }
      // {
      //     "cMode": 0,
      //     "directLinkMedia": "/hlmocha223/media1/file/2023/11/24/0396/7830/58/484eee1e60de0c11f222884225b9bee6.jpg",
      //     "duration": "0",
      //     "fileName": "20231124_072806.jpg",
      //     "filePath": "/storage/emulated/0/Android/data/com.viettel.mocha.app.mochatest/files/.Cache/copy_20231124_072806.jpg",
      //     "fileSize": "1743555",
      //     "from": "0396783058",
      //     "imageUrl": "null",
      //     "stp": "file",
      //     "pId": "0102003_13461711039A49059F01F8000E3409DB",
      //     "readState": 1,
      //     "status": 8,
      //     "svId": "0396783058_1700789931004",
      //     "t": 1700805979975,
      //     "to": "0396783058_1700789931004"
      // }
      case NODE_SUBTYPE_MESSAGE.FILE: {
        const fileMsg = Drafty.attachFile(null, {
          mime: Helpers.getMimeType(this.fileName),
          filename: this.fileName,
          size: this.fileSize,
          refurl: this.directLinkMedia,
        });
        msgData.content = fileMsg;
        msgData.head = { mime: Drafty.getContentType() };

        this.addTopicSharedFile(topic, this.id, this.directLinkMedia, this.fileSize, this.fileName, Number(this.timeReceive))

        break
      }
      // {
      //     "body": "",
      //     "cMode": 0,
      //     "directLinkMedia": "/hlmocha223/media1/file/2023/11/24/0396/7830/58/42dd486cb6630ee76e65188197e9f157.mp4",
      //     "duration": "16023",
      //     "fileName": "ac7e08b2964cd5d2fd3c621d6e06421a_1700795716692.mp4",
      //     "fileSize": "3732203",
      //     "from": "0396783058",
      //     "imageUrl": "https://devapi.mocha.com.vn/hlmocha223/media1/file/2023/10/20/0396/7830/58/c2cd783560d15f188d195c1d4862b1b3.jpg?apikey=AQEAAAABAAD_rAp4DJh05a1HAwFT3A6K",
      //     "stp": "shareVideo",
      //     "pId": "0502000_IPZUAYWIGRF1OQFVFDSKNRHNEBBSHQ6D",
      //     "readState": 1,
      //     "status": 8,
      //     "svId": "0396783058_1700789931004",
      //     "t": 1700795715996,
      //     "to": "0396783058"
      // }
      case NODE_SUBTYPE_MESSAGE.VIDEO: {
        const videoMsg = Drafty.insertVideo(null, 0, {
          mime: Helpers.getMimeType(this.fileName),
          duration: this.duration,
          filename: this.fileName,
          size: this.fileSize,
          refurl: this.directLinkMedia,
          preref: this.imageUrl,
        });
        msgData.content = videoMsg;
        msgData.head = { mime: Drafty.getContentType() };
        break
      }
      // {
      //     "fileSize": "21007",
      //     "status": 8,
      //     "t": "1703059211898",
      //     "cMode": "1",
      //     "directLinkMedia": "/hlmocha223/media1/file/2023/12/20/0855/8970/52/ac841d26965b2390f21b7f93aa1aa171.",
      //     "fileName": "ver2_MToYF4LLSj38Pv7JmlZS5FrboFB_kahIZxN9QJ3cv2HdKir3cdWTA3MPv6JUNCuv_wEw5qL2RO0oztC7em4kFOCGw4UwuA0XtrIWsgOvvl0SQ3dBrPk3Iw",
      //     "pId": "702C6F40F28248FF86F504F9B156304B",
      //     "to": "0855897052",
      //     "stp": "voicemail",
      //     "from": "0855897052",
      //     "ratio": "6.176471",
      //     "svId": "0383764349"
      // }
      case NODE_SUBTYPE_MESSAGE.AUDIO: {
        const audioMsg = Drafty.appendAudio(null, {
          mime: Helpers.getMimeType(this.fileName && this.fileName.includes('.') ? this.fileName : '.mp3'),
          name: this.fileName,
          size: this.fileSize,
          duration: (this.duration * 1000) || 0,
          refurl: this.directLinkMedia,
        });
        msgData.content = audioMsg;
        msgData.head = { mime: Drafty.getContentType() };
        break;
      }
    }
  }

  addTopicSharedImage(topic, id, mediaLink) {
    try {
      const imageObj = {
        messageId: id,
        media_link: mediaLink,
      }
      if (topic?.shareImage && Array.isArray(topic.shareImage)) {
        topic.shareImage.unshift(imageObj)
      } else {
        topic.shareImage = [imageObj]
      }

      // topic._routeData({});
    } catch (e) {
      console.error(e)
    }
  }

  addTopicSharedFile(topic, id, mediaLink, size, fname, timeMsgSend) {
    try {
      const fileInfo = {
        messageId: id,
        media_link: mediaLink,
        size,
        name: fname,
        timesend: timeMsgSend
      }
      if (Array.isArray(topic.shareFile)) {
        topic.shareFile.unshift(fileInfo)
      } else {
        topic.shareFile = [fileInfo]
      }

      // topic._routeData({});
    } catch (e) {
      console.error(e)
    }

  }
}

export default new RestoreServices();
